import {
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ExamCenterService } from '../../../services';

@Component({
  selector: 'app-exam-center-table-filter',
  templateUrl: './exam-center-table-filter.component.html',
  styleUrls: ['./exam-center-table-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExamCenterTableFilterComponent
  implements OnInit, OnDestroy
{
  searchControl!: UntypedFormControl;
  private searchSubscription!: Subscription;
  private timeToWaitBeforeUpdateMs = 250;

  constructor(private service: ExamCenterService) {}

  ngOnInit(): void {
    this.searchControl = new UntypedFormControl(
      this.service.listState.filter.search
    );
    this.searchSubscription =
      this.searchControl.valueChanges
        .pipe(debounceTime(this.timeToWaitBeforeUpdateMs))
        .subscribe((value) => {
          this.service.listState.filter.search = value;
          this.reload();
        });
  }

  reload(): void {
    this.service.loadList();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
